import { render, staticRenderFns } from "./BasePageBreadcrumbs.vue?vue&type=template&id=32853cae&"
import script from "./BasePageBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./BasePageBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports